import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthContainer from './AuthContainer';

interface PrivateRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireAdmin = false }) => {
  const { user, isAdmin } = useAuth();

  if (!user) {
    return <AuthContainer />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="mcmv-form-container">
        <div className="form-header">
          <h1>Acesso Negado</h1>
          <p>Você não tem permissão para acessar esta área.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;